import { getBasicContentSchema } from '@/lib/zy-tiptap-utils';
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ZyBlockNodeView } from './zyblock-node-view';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyBlock: {
            insertZyBlock: () => ReturnType;
            setZyBlock: () => ReturnType;
            toggleZyBlock: () => ReturnType;
            unsetZyBlock: () => ReturnType;
        };
    }
}

export const ZyBlockHeadless = Node.create({
    name: 'zyBlock',

    content: function () {
        return getBasicContentSchema();
    },

    group: 'block',

    defining: true,

    isolating: true,

    addAttributes() {
        return {
            nobox: {
                default: false,
                parseHTML: element => {
                    const style = element.getAttribute('style') || '';
                    const match = style.match(/background-color:\s*([^;]+)/);
                    return match ? match[1].trim() === 'transparent' : false;
                },
                renderHTML: attributes => {
                    if (attributes.nobox) {
                        return {
                            style: 'background-color: transparent;',
                        };
                    }
                    return {};
                },
            },
            id: {
                default: null,
                parseHTML: element => {
                    return element.getAttribute('id') || null;
                },
                renderHTML: attributes => {
                    if (!attributes.id) {
                        return {};
                    }
                    return {
                        id: attributes.id,
                    };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'div.zyblock',
                getAttrs: element => {
                    const style = element.getAttribute('style') || '';
                    const match = style.match(/background-color:\s*([^;]+)/);
                    return {
                        nobox: match ? match[1].trim() === 'transparent' : false,
                        id: element.getAttribute('id'),
                    };
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', { class: 'zyblock', ...HTMLAttributes }, 0];
    },

    addCommands() {
        return {
            insertZyBlock:
                () =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: 'zyBlock',
                        content: [
                            {
                                type: 'paragraph',
                                content: [{ type: 'text', text: 'Block content' }],
                            },
                        ],
                    });
                },
            setZyBlock:
                () =>
                ({ commands }) => {
                    return commands.wrapIn(this.name);
                },
            toggleZyBlock:
                () =>
                ({ commands }) => {
                    return commands.toggleWrap(this.name);
                },
            unsetZyBlock:
                () =>
                ({ commands }) => {
                    return commands.lift(this.name);
                },
        };
    },
});

export const ZyBlock = ZyBlockHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyBlockNodeView);
    },
});

export default ZyBlock;
